<app-feature-list-container
  title="{{ '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.DETAILS' | translate }}"
  tooltipText="{{ '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.DETAILS_TOOLTIP' | translate }}"
>
  <div class="details">
    <div class="details-column">
      <!-- heating.sensors.volumetricFlow.allengra -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="heatingWaterVolumeFlow"
        *ngIf="internalHydraulicHeatingWaterVolumeFlow$ | async | ready as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.HEATING_WATER_VOLUME_FLOW' | translate
        "
        [description]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.HEATING_WATER_VOLUME_FLOW_DESCRIPTION'
            | translate
        "
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
      >
      </app-feature-list-item>

      <!-- heating.sensors.pressure.supply -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="systemPressure"
        *ngIf="internalHydraulicSystemPressure$ | async | ready as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.SYSTEM_PRESSURE' | translate"
        [description]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.SYSTEM_PRESSURE_DESCRIPTION' | translate
        "
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
      >
      </app-feature-list-item>

      <!-- heating.secondaryCircuit.valves.fourThreeWay/target -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="fourThreeWayValveTargetPosition"
        *ngIf="internalHydraulicFourThreeWayValvePosition$ | async | ready as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.FOURTHREE_WAY_VALVE_TARGET_POSITION'
            | translate
        "
        [description]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.FOURTHREE_WAY_VALVE_TARGET_POSITION_DESCRIPTION'
            | translate
        "
        value="{{ feature | ready | value2: featurePropertyKey.target }} {{
          feature | unit: featurePropertyKey.target
        }}"
      >
      </app-feature-list-item>

      <!-- heating.secondaryCircuit.valves.fourThreeWay/current -->
      <ng-container
        *ngrxLet="{
          internalHydraulicFourThreeWayValve: internalHydraulicFourThreeWayValve$ | async,
          internalHydraulicFourThreeWayValvePosition:
            internalHydraulicFourThreeWayValvePosition$ | async
        } as features"
      >
        <app-feature-list-item
          data-at-refrigerant-circuit-overlay-feature="fourThreeWayValveActualPosition"
          *ngIf="
            features.internalHydraulicFourThreeWayValvePosition &&
            features.internalHydraulicFourThreeWayValve
          "
          [label]="
            '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.FOURTHREE_WAY_VALVE_ACTUAL_POSITION'
              | translate
          "
          [description]="
            '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.FOURTHREE_WAY_VALVE_ACTUAL_POSITION_DESCRIPTION'
              | translate
          "
          value=" {{
            features.internalHydraulicFourThreeWayValve | value2: featurePropertyKey.current
          }} {{
            features.internalHydraulicFourThreeWayValve | unit: featurePropertyKey.current
          }} ({{
            features.internalHydraulicFourThreeWayValvePosition
              | value2: featurePropertyKey.value
              | internalHydraulicTranslations
          }})"
        >
        </app-feature-list-item>
      </ng-container>
    </div>
    <div class="details-column">
      <!-- heating.boiler.pumps.internal.target -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="primaryCircuitPumpSetpoint"
        *ngIf="primaryCircuitPumpSetpoint$ | async | ready as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.PRIMARY_CIRCUIT_PUMP_SETPOINT' | translate
        "
        [description]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.PRIMARY_CIRCUIT_PUMP_SETPOINT_DESCRIPTION'
            | translate
        "
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
      >
      </app-feature-list-item>

      <!-- heating.boiler.pumps.internal.current -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="actualVolumeFlowAtPrimaryCircuitPump"
        *ngIf="internalHydraulicActualVolumeFlow$ | async | ready as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.ACTUAL_VOLUME_FLOW_AT_PRIMARY_CIRCUIT_PUMP'
            | translate
        "
        [description]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.ACTUAL_VOLUME_FLOW_AT_PRIMARY_CIRCUIT_PUMP_DESCRIPTION'
            | translate
        "
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
      >
      </app-feature-list-item>

      <!-- heating.configuration.internalPumps/maximumLimit -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="maximumLimit"
        *ngIf="internalHydraulicConfigurationInternalPumps$ | async | ready as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.MAXIMUM_LIMIT' | translate"
        [description]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.MAXIMUM_LIMIT_DESCRIPTION' | translate
        "
        value="{{ feature | value2: featurePropertyKey.maximumLimit }} {{
          feature | unit: featurePropertyKey.maximumLimit
        }}"
      >
      </app-feature-list-item>

      <!-- heating.configuration.internalPumps/minimumLimit -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="minimumLimit"
        *ngIf="internalHydraulicConfigurationInternalPumps$ | async | ready as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.MINIMUM_LIMIT' | translate"
        [description]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.MINIMUM_LIMIT_DESCRIPTION' | translate
        "
        value="{{ feature | value2: featurePropertyKey.minimumLimit }} {{
          feature | unit: featurePropertyKey.minimumLimit
        }}"
      >
      </app-feature-list-item>
    </div>
    <div class="details-column">
      <!-- heating.boiler.sensors.temperature.commonSupply -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="commonFlowTemperature"
        *ngIf="internalHydraulicCommonFlowTemperature$ | async | ready as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.COMMON_FLOW_TEMPERATURE' | translate
        "
        [description]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.COMMON_FLOW_TEMPERATURE_DESCRIPTION'
            | translate
        "
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
      >
      </app-feature-list-item>

      <!-- heating.sensors.temperature.return -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="returnTemperature"
        *ngIf="internalHydraulicReturnTemperature$ | async | ready as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.RETURN_TEMPERATURE' | translate"
        [description]="
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.RETURN_TEMPERATURE_DESCRIPTION'
            | translate
        "
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
      >
      </app-feature-list-item>
    </div>
  </div>
</app-feature-list-container>
